export enum TextFilterModeEnum {
  Contains = "contains",
  StartsWith = "starts_with",
  EndsWith = "ends_with",
  Exact = "exact",
}
export enum NumberFilterModeEnum {
  GreaterThan = "greater_than",
  LessThan = "less_than",
  GreaterThanOrEquals = "greater_than_or_equals",
  LessThanOrEquals = "less_than_or_equals",
  Equals = "equals",
  NotEquals = "not_equals",
  Between = "between",
}
